import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { can, canAny, canAll } from '../utils/helpers/can';

// Read the active-society permission set from redux and return helpers.
// Server still enforces — these helpers are purely for UI affordances.
export const usePermissions = () => {
  const { permissions, activeRole, activeSociety, permissionsLoading } = useSelector(
    (s) => s.UserSocietyReducer
  );

  return useMemo(
    () => ({
      permissions: permissions || [],
      role: activeRole,
      society: activeSociety,
      loading: permissionsLoading,
      can: (perm) => can(permissions, perm),
      canAny: (perms) => canAny(permissions, perms),
      canAll: (perms) => canAll(permissions, perms),
    }),
    [permissions, activeRole, activeSociety, permissionsLoading]
  );
};

export default usePermissions;
